import styled from 'styled-components';

export const Wrapper = styled.div`
    position: fixed;
    z-index: 999;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Modal = styled.div`
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    width: 520px;
    max-height: 90vh;
    overflow-y: auto;
    padding: 32px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    color: #555;
    font-weight: 500;
    font-size: 13px;
    box-sizing: border-box;
    position: relative;
    cursor: default;
    hr {
        height: 1px;
        background: #ccc;
        width: 100%;
        margin-block: 32px;
    }

    @media (max-width: 767px) {
        width: 100%;
        height: 100vh;
        max-height: unset;
        border-radius: 0;
        border: none;
        padding: 20px;
        display: flex;
        flex-direction: column;
    }
`;

export const Header = styled.div`
    text-align: center;
    display: flex;
    flex-direction: column;
`;

export const Title = styled.span`
    font-size: 24px;
    margin-block-end: 8px;
`;
